module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-4-d17a4313.jpg";